import { FC, useEffect, useState, Fragment } from "react";
import { useTranslation } from "react-i18next";

import Container from "components/__reusable/Container";
import AccordionItem from "components/__reusable/AccordionItem";
import { SupportedLang } from "config/constants";
import type { FAQ } from "types/SupportMaterial";
import QIcon from "assets/icons/QIcon";

interface CategoryProp {
  faqs: FAQ[];
  onSelect: (categoryId: number) => void;
}

const Category: FC<CategoryProp> = ({ faqs, onSelect }) => {
  const { t, i18n } = useTranslation();
  const [faqCategories, setFaqCategories] = useState<number[]>([]);
  const [previewFaq, setPreviewFaq] = useState<{ [key: string]: FAQ[] }>({});

  useEffect(() => {
    const categories = [];
    const previewFaq: { [key: string]: FAQ[] } = {};
    for (let faq of faqs) {
      if (!previewFaq[faq.category_id]) {
        previewFaq[faq.category_id] = [faq];
        categories.push(faq.category_id);
        continue;
      }

      if (
        previewFaq[faq.category_id] &&
        previewFaq[faq.category_id].length < 3
      ) {
        previewFaq[faq.category_id].push(faq);
      }
    }
    setPreviewFaq(previewFaq);
    setFaqCategories(categories);
  }, [faqs]);

  return (
    <Fragment>
      {faqCategories.map((category) => (
        <div key={category} className="flex-1">
          <Container>
            <div className="space-y-2">
              <div
                className="item-header flex justify-between items-center cursor-pointer rounded p-2 hover:bg-[#F4F4F4] transition-colors"
                onClick={() => onSelect(category)}
              >
                <h3 className="text-xl font-bold">
                  {i18n.language === SupportedLang.ja
                    ? previewFaq[category][0].category_ja
                    : previewFaq[category][0].category_en}
                </h3>
                <button
                  type="button"
                  className="text-primary underline hover:no-underline"
                >
                  {t("_faq._view_more")}
                </button>
              </div>
              <div className="space-y-1">
                {previewFaq[category].map((faq, index) => (
                  <AccordionItem
                    key={`${category}-${index}`}
                    headerClassName="hover:bg-[#F4F4F4] transition-colors"
                    titleElement={
                      <div className="flex items-start gap-2 flex-1">
                        <div className="flex-shrink-0">
                          <QIcon width={18} height={22} />
                        </div>
                        <h4 className="text-base font-medium">
                          {i18n.language === SupportedLang.ja
                            ? faq.question_ja
                            : faq.question_en}
                        </h4>
                      </div>
                    }
                    contentElement={
                      <p
                        className="p-2 bg-[#fdf1f3] text-lg text-[#707070] text-wrap"
                        dangerouslySetInnerHTML={{
                          __html:
                            i18n.language === SupportedLang.ja
                              ? faq.answer_ja
                              : faq.answer_en,
                        }}
                      ></p>
                    }
                  />
                ))}
              </div>
            </div>
          </Container>
        </div>
      ))}
    </Fragment>
  );
};

export default Category;
